import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ProductInformationCache from '../persistence/description-cache';
import I10n from '../features/i10n';
import ProductLink from './product_link';
import Checkbox from './options_selector/options_components/checkbox';
import MsxIcons from '../features/msx-icons';
import { PRIMARY_COLOR, SECONDARY_COLOR } from '../color-constants';
import Tooltip from './documentation/tootip';
import { PRECOMM_STATUS } from '../constants';

const Container = styled.div`
  background-color: white;
  margin: 5px 5px 5px 5px;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  overflow: visible;
  &:last-child {
    margin-bottom: 0px;
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  color: black;
  cursor: pointer;
  margin: 0 15px;
`;

const ImageBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 20px;
  align-items: center;
`;

const Image = styled.img`
  width: 70px;
  height: 70px;
`;

const ReferencesBox = styled.div`
  height: 100%;
  overflow: visible;
`;

const VerticalCenter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  min-width: 130px;
`;

const EmptyText = styled.span`
  display: inline-block;
  margin-right: 5px;
  font-size: 12px;
  line-height: 14px;
  font-weight: bold;
`;

const DatasheetWrapper = styled.div`
  ${props => props.isSelected ? `
    color: white;
    color: var(--se-primary-contrast, white);
  ` : `
    color: ${PRIMARY_COLOR};
    color: var(--se-secondary, ${PRIMARY_COLOR});
  `}
`;

const ReferenceDescriptionWrapper = styled(VerticalCenter)`
  position: relative;
  padding-left: 20px;
  min-width: 0px;
  width: 100%;
  overflow: hidden;
  @media (max-width: 800px) {
    padding-left: 0px;
  }
`;

const ReferenceDescription = styled.span`
  display: inline-block;
  font-size: 13px;
  line-height: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  @media (max-width: 800px) {
    text-overflow: unset;
    white-space: pre-wrap;
  }
  @media (max-width: 500px) {
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;


const ReferenceActions = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 12px;
  line-height: 14px;
  margin-left: 4px;
  flex: 1 1 0px;
  justify-content: flex-end;
`;

const ReferenceSelectActionWrapper = styled(VerticalCenter)`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 80px;
  @media (max-width: 800px) {
    min-width: 0px;
  }
`;

const ReferenceID = styled.span`
  display: inline-block;
`;

const ReferenceTile = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 40px;
  padding: 0px 10px;
  border-bottom: 1px solid #e5e5e5;
  cursor: pointer;
  &:last-child {border-bottom: none;}
  ${props => props.selected ? `
    background-color: ${SECONDARY_COLOR};
    background-color: var(--se-primary, ${SECONDARY_COLOR});
    color: white !important;
    color: var(--se-primary-contrast, white) !important;
  ` : `
    color: #626469 !important;
    background-color: white;
    :hover {
      background-color: #EDEDED;
    }
  `}
  overflow: visible;
  transition: opacity 0.2s ease 0s;
  text-decoration: none !important;

  @media (max-width: 800px) {
    height: auto;
    padding: 5px;
  }
`;

const InformationBox = styled.div`
  position: relative;
  width: 100%;
  margin-left: 10px;
`;

const SelectedChip = styled.span`
  display: inline-flex;
  padding-left: 8px;
  padding-right: 8px;
  font-weight: 400;
  text-align: left;
  align-items: center;
  margin-right: 4px;
  outline: none;
  border-radius: 16px;
  font-size: 12px;
  line-height: 18px;
  margin-bottom: 10px;

  color: black;
  background-color: #ecedf1;
`;

const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 800px) {
    display: inline-flex;
    flex-direction: column;
  }
`;

const CountBox = styled.span`
  display: flex;
  align-items: center;
  font-weight: bold;
  color: #424242;
  font-size: 10px;
  line-height: 18px;
  margin-bottom: 0px;
  width: 120px;

`;

const Title = styled.h4`
  margin: 0px;
  font-weight: bold;
  margin-right: 4px;
  margin-bottom: 10px;
  font-size: 18px !important;
  line-height: normal !important;
  text-align: left !important;
`;

const Description = styled.p`
  color: #626469;
  font-size: 13px !important;
  line-height: 18px !important;
  margin: 0;
  color: ${SECONDARY_COLOR};
  color: var(--se-primary, ${SECONDARY_COLOR});
`;

const ReferenceAndDescWrapper = styled.div`
  display: flex;
  overflow: hidden;
  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

const TooltipContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0px 5px;
  min-width: 24px;
`;

const StyledCheckboxWrapper = styled.div`
svg {
  border: 1px solid white;
}
`;

const ReferenceToggleIcon = styled(MsxIcons)`
  margin-right: 10px;
`;

const EmptyIcon = styled.span`
  width: 24px;
  height: 24px;
  margin-right: 10px;
`;

const TooltipContentContainer = styled.div`
  background-color: rgba(217, 217, 217, 1);
  color: #0f0f0f;
  padding: 5px;
  display: flex;
  flex-direction: column;
  padding: 10px;
`;

const TooltipHeader = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 900;
  margin-bottom: 5px;
  min-width: 200px;
`;

const TooltipDescription = styled.div`
  display: flex;
  font-size: 12px;
  align-content: center;
  white-space: nowrap;
`;

const ReferenceIDWrapper = styled(VerticalCenter)`
  margin-right: 5px;
  font-size: 12px;
  line-height: 14px;
  font-weight: bold;
`;
class ModuleCategory extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    }
    this.categoryRef = React.createRef();
  }

  static propTypes ={
    id: PropTypes.string,
  }

  open = () => {
    this.setState({
      isOpen: true,
    });
    this.props.onOpenStateChange(true, this.categoryRef);
  }

  close = () => {
    this.setState({
      isOpen: false,
    });
    this.props.onOpenStateChange(false, this.categoryRef);
  }
  renderTooltipContent = ({ icon, title, message }) => (
    <TooltipContentContainer>
      <TooltipHeader>
        <MsxIcons name={icon} size="small"/>
        <span style={{ marginLeft: '5px' }}>{title}</span>
      </TooltipHeader>
      <TooltipDescription>{message}</TooltipDescription>
    </TooltipContentContainer>
  );

  renderReferences = () => {
    const references = this.props.references || [];
    if (references.length) {
      return references.sort((a, b) => a.id.localeCompare(b.id))
        .map((reference, key) => {
          const desc = ProductInformationCache.getDescription(reference.id) || reference.description;
          const isSelected = this.props.selectedDevice && this.props.selectedDevice.id === reference.id;
          const onSelect = (event) => {
            event.preventDefault();
            this.props.setSelectedDevice(reference);
          };

          const id = `${reference.id}-module-category`;
          return (
            <ReferenceTile key={key}
              id={id}
              selected={isSelected}
              onClick={onSelect}
            >
              <DatasheetWrapper isSelected={isSelected}>
                <ProductLink reference={reference.id} isIcon={true}></ProductLink>
              </DatasheetWrapper>
               <TooltipContainer>
                {(reference.commercializationStatus === PRECOMM_STATUS) &&
                  <Tooltip
                    toggleElement={<MsxIcons name="info" size="small"></MsxIcons>}
                    containerElement={this.renderTooltipContent({
                      icon: "info_hover",
                      title: I10n.get('precommercialization.tooltip.title'),
                      message: I10n.get('screen.head_device_selector_screen.tooltip'),
                    })}
                    boundingElement={this.props.boundingElementTooltip}
                    allowTop={true}
                    triangleColor={'#D9D9D9'}
                  />}
              </TooltipContainer>
              <ReferenceAndDescWrapper>
                  <ReferenceIDWrapper>
                    <ReferenceID>{reference.id}</ReferenceID>
                  </ReferenceIDWrapper>
                  <ReferenceDescriptionWrapper>
                    <ReferenceDescription title={desc}>{desc}</ReferenceDescription>
                  </ReferenceDescriptionWrapper>
              </ReferenceAndDescWrapper>

              <ReferenceActions>
                <ReferenceSelectActionWrapper>
                  {isSelected && (
                    <StyledCheckboxWrapper id='Module-Cat1'>
                    <Checkbox
                      checked={!!isSelected}
                      onChange={onSelect}
                      label={I10n.get('module_category.reference.selected')}
                      style={{ backgroundColor: isSelected ? 'red' : '', color: isSelected ? 'blue' : '' }}
                    />
                    </StyledCheckboxWrapper>
                  )}
                </ReferenceSelectActionWrapper>
              </ReferenceActions>

            </ReferenceTile>
          );
        });
    } else {
      return (
        <ReferenceTile>
          <ReferenceIDWrapper>
            <EmptyText>{I10n.get('module_category.empty')}</EmptyText>
          </ReferenceIDWrapper>
        </ReferenceTile>
      );
    }
  }

  render = () => {

    const referencesNum = this.props.references ? this.props.references.length : 0;
    const showReferences = this.state.isOpen || this.props.forceOpen || referencesNum === 1;
    const haveSelectedDevice = !showReferences && this.props.selectedDevice && this.props.references.map(d => d.id).includes(this.props.selectedDevice.id);
    return (
      <Container ref={this.categoryRef} >
        <Header
          id={this.props.id + '-range-category'}
          onClick={(event) => {
            event.preventDefault();
            this.state.isOpen ? this.close() : this.open();
          }}
          isOpen={this.state.isOpen}>

          {!!this.props.image && this.props.image.length > 0 &&
            <ImageBox>
              <Image src={this.props.image} alt={this.props.imageAlt || this.props.title}></Image>
            </ImageBox>}
          <InformationBox>
          <TitleRow>
              <Title>{this.props.title}</Title>
              {haveSelectedDevice && <SelectedChip>
                {I10n.getAndReplace(`module_category.selected_reference`, this.props.selectedDevice.id)}
              </SelectedChip>}

              {!this.state.isOpen &&
              <CountBox>
                {referencesNum > 1 && !this.props.forceOpen ? (
                  <ReferenceToggleIcon
                    name={this.state.isOpen ? "up-arrow" : "down-arrow"}
                    size="small"
                    style={{fontWeight: 'bold'}}
                  />
                ) : (
                  <EmptyIcon/>
                )}
                {I10n.getAndReplace(`module_category.references_count${referencesNum <= 1 ? `.${referencesNum}` : ''}`, referencesNum)}
              </CountBox>}
            {this.state.isOpen &&
              <CountBox>
                {referencesNum > 1 && !this.props.forceOpen ? (
                  <ReferenceToggleIcon name="up-arrow" size="small"/>
                ) : (
                  <EmptyIcon/>
                )}
                {I10n.getAndReplace(`module_category.references_count${referencesNum <= 1 ? `.${referencesNum}` : ''}`, referencesNum)}
              </CountBox>}

            </TitleRow>
            <Description>{this.props.description}</Description>
          </InformationBox>
        </Header>
        {
          showReferences && <ReferencesBox id='RefBox'>
            {this.renderReferences(this.props.label)}
          </ReferencesBox>
        }
      </Container >
    );
  }

  static propTypes = {
    title: PropTypes.string,
    label: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.string,
    imageAlt: PropTypes.string,
    references: PropTypes.array,
    selectedDevice: PropTypes.object,
    setSelectedDevice: PropTypes.func,
    withCount: PropTypes.bool,
    onOpenStateChange: PropTypes.func,
    forceOpen: PropTypes.bool,
    datasheetTemplate: PropTypes.string,
    id: PropTypes.string,
    isFilterOpen: PropTypes.bool
  }
}

export default ModuleCategory;
